import { render, staticRenderFns } from "./PartExchange.vue?vue&type=template&id=4cbf003f&scoped=true"
import script from "./PartExchange.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartExchange.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PartExchange.vue?vue&type=style&index=0&id=4cbf003f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf003f",
  null
  
)

export default component.exports